export const linkColor = '#2099ca'
export const grayColor = '#ccc'
export const grayTextColor = '#888'
export const alertColor = '#d80000'
export const offColor = '#939393'
